import { SingleViewStateRecord } from '@common/data-models/records/single-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { GlobalTablesService } from "@common/services/global-tables-service";

export class SearchViewStateRecord extends SingleViewStateRecord {

    public initialize() {
        this.viewStateType = ViewStateTypes.SEARCH;
        super.initialize();
    }

    public get viewStateSearchQuery(): string { return this.getAs<string>("PSTViewStateSearchQuery"); }
    public set viewStateSearchQuery(value: string) { this.set("PSTViewStateSearchQuery", value); }
}
